import { getDefaultBrandDirectOnlyShopConfig, getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { FooterLogo, HeroAction } from '../../types/shopConfig/shopConfigV2';
import { getGenderFilterConfig } from '../filters/gender';
import { BuilderSections } from '../../util/builder';

const tentreeSizes = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'ONE',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '22',
  '30',
  '31',
  '32',
  '34',
  '35',
  '36',
  '38',
  '40',
];

export const tentreeShopConfig = {
  ...getDefaultShopConfig(),
  ...getDefaultBrandDirectOnlyShopConfig('tentree'),
  filters: [
    ...custom.filters,
    getGenderFilterConfig(),
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: tentreeSizes,
    }),
  ],
  heroActions: [
    { type: HeroAction.Shop },
    {
      type: HeroAction.ExternalLink,
      config: { label: 'Send In', url: 'https://tentree.supercircle.world/landing/' },
    },
  ],
  footerLogos: [FooterLogo.Brand, FooterLogo.Treet, FooterLogo.SuperCircle],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'e311718e8acc41419ae746bdb0c32456',
    },
  },
};
